import { Colors } from "../consts/Colors";
import Entity from "./Entity";

export default class Player extends Entity {
    constructor(scene, x, y, params = { showHitbox: true, level: level }) {
        super(scene, x, y, params);

        this.scene = scene;
        this.isHited = false
        scene.add.existing(this);
    }
    
    addBody(params) {
        this.level = params.level

        if (this.level === 0 || this.level === 1) {
            this.texture = this.scene.add.sprite(0, 0, 'tortue').setOrigin(0.5)
            this.texture.anims.play('turtleAnim');
            this.add(this.texture)
        } else if (this.level === 2) {
            this.textureNet = this.scene.add.sprite(0, 0, 'tortueNet').setOrigin(0.5)
            this.textureNet.anims.play('turtleNetAnim');
            this.add(this.textureNet)
        }
        this.addHitbox()
        this.displayHitbox(params.showHitbox)
    }

    addHitbox() {
        this.hitbox = this.scene.add.rectangle(0, 0, 214*0.36, 118*0.36, Colors.Elmt.Black, 0.4).setOrigin(0.5)
        this.add(this.hitbox)
    }

    displayHitbox(isVisible) {
        this.hitbox.setAlpha(isVisible ? 1 : 0)
    }
}